<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/92SUBg/tc-custom/9781399093507.jpg?1705006398130" alt="This image is the cover for the book Shakespeare's Other Son?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Shakespeare's Other Son?
      </h1>
      <p class="bookDescription body article font2">
        <p>Sir William Davenant (1606-1668) was in his time widely known as 'Davenant the Poet'. The son of an Oxford vintner (or quite possibly the natural son of his godfather, William Shakespeare), he wrote poems for and about the Court of Charles I, and, despite losing his nose to mercury treatment for the clap, which other people thought funny, went on to replace Ben Jonson as Poet Laureate and collaborate with Inigo Jones in composing spectacular Court masques, as well as writing many successful plays -- a few fashionably blood-thirsty, most showing a real comic gift, humanity and sympathy with 'ordinary life'.  In the Civil War, he earned a knighthood as an especially successful gun-runner for the Royalists, before escaping to Paris, where he worked on an epic poem. Then sent off by Charles II to colonize Virginia but captured by the Parliamentarians, he escaped execution but was imprisoned for five years. With the Restoration, he practically re-invented English theatre, with the first English opera, women actors, movable scenery and the proscenium arch, as well as reviving interest in Shakespeare with inventive adaptations. Energetic, affable and resilient, he was an appealing and well-liked character.  Celebrated and important in his day, Davenant is now surprisingly little known. This enterprising study introduces modern readers to his wit, poetry, and growing scepticism as to Court and aristocratic values, and his developing feminist sympathies. Here, select excerpts and summaries bring this entertaining writer to a new, wider audience.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        R.E. Pritchard
      </h2>
      
      <p class="authorDescription body article">Born in India, R.E. Pritchard read English at Balliol College, Oxford, before becoming a lecturer at Keele University. He has published widely on a range of sixteenth- and seventeenth-century subjects, from Shakespeare’s England to the court of Charles II. He lives in West Oxfordshire.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Military
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fae63ea2